import { NestedArrayHandler } from "../../../handlers";
import { validators } from "./validators";
/**
 * Handles publisher cap operations.
 * Caps are associated with publishers and represent specific limits or thresholds.
 */
class PublisherSettings extends NestedArrayHandler {
    constructor(sdk) {
        super(sdk, "publisherSettings");
        this.validators = validators;
    }
    getIdentifierKey() {
        return "publisherId";
    }
    getKeyPath() {
        return "publisherSettings";
    }
}
export default PublisherSettings;
//# sourceMappingURL=index.js.map